if(/firefox/i.test(navigator.userAgent)){
  var oldGetComputedStyle = window.getComputedStyle;
  window.getComputedStyle = function(el, pseudoElt){
    var result = oldGetComputedStyle(el, pseudoElt);
    if(result === null){
      return {};
    }else{
      return result;
    }
  };
}
